import {ActionReducerMap} from '@ngrx/store';
import {DatevWizardState} from './datev-wizard.state';
import {datevWizardGetFirmaReducers,} from '../datev-wizard-get-firma/+store/datev-wizard-get-firma.reducers';
import {datevWizardClientIdReducers} from '../datev-wizard-client-id/+store/datev-wizard-client-id.reducers';
import {datevWizardExportDateReducers} from '../datev-wizard-export-date/+store/datev-wizard-export-date.reducers';
import {
  datevWizardConfigDetailsReducers
} from '../datev-wizard-config-details/+store/datev-wizard-config-details.reducers';
import {datevWizardLoginReducers} from '../datev-wizard-login/+store/datev-wizard-login.reducers';
import {datevWizardCaseSelectionReducer} from '../datev-wizard-case-selection/+store/datev-wizard-case-selection.reducers';


export const datevWizardReducers: ActionReducerMap<DatevWizardState> = {
  datevWizardGetFirma: datevWizardGetFirmaReducers,
  datevWizardCaseSelection: datevWizardCaseSelectionReducer,
  datevWizardClientId: datevWizardClientIdReducers,
  datevWizardExportDate: datevWizardExportDateReducers,
  datevWizardConfigDetails: datevWizardConfigDetailsReducers,
  datevWizardLogin: datevWizardLoginReducers,
};
